import React, { Suspense, lazy } from "react";
import Grid from "./grid";
import Hero from "./hero";
import LinearGrid from "./linearGrid";
import Iframe from "./iframe";
import Multimedia from "./multimedia";
import RichText from "./richText";
import TeaserWithIcon from "./teaserWithIcon";
import TeaserWithImage from "./teaserWithImage";
import TestimonialItem from "./testimonialItem";
import TextVisual from "./textVisual";

const Map = lazy(() => import("./map"));

const MapPlaceholder = () => (
  <div style={{ minHeight: 210, background: "#f0f0f0" }} aria-hidden="true" />
);

// Mapbox GL requires browser APIs - never load during Gatsby SSR
const MapWithSuspense = (props) => {
  if (typeof window === "undefined") {
    return <MapPlaceholder />;
  }
  return (
    <Suspense fallback={<MapPlaceholder />}>
      <Map {...props} />
    </Suspense>
  );
};

//
// Content type - Component map
//
export const dynamicComponents = {
  ContentfulTeaserWithIconComponent: TeaserWithIcon,
  ContentfulTeaserWithImageComponent: TeaserWithImage,
  ContentfulTextVisualComponent: TextVisual,
  ContentfulMultimedia: Multimedia,
  ContentfulMapComponent: MapWithSuspense,
  ContentfulHeroComponent: Hero,
  ContentfulGridComponent: Grid,
  ContentfulTestimonial: TestimonialItem,
  ContentfulTextComponent: RichText,
  ContentfulLinearGridComponent: LinearGrid,
  ContentfulIframeComponent: Iframe,
};

export const renderDynamicComponents = (components) => {
  return components?.map((component, index) =>
    renderDynamicComponent(component)
  );
};

export const renderDynamicComponent = (component) => {
  if (!component.internal) return null;
  const DynamicComponent = dynamicComponents[component.internal.type];
  return DynamicComponent ? <DynamicComponent {...component} /> : null;
};
